"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function reducer(state, action) {
    var _a;
    switch (action.type) {
        case 'SET_VALUE':
            return __assign(__assign({}, state), (_a = {}, _a[action.name] = action.value, _a));
        case 'CLEAR':
            return __assign({}, action.payload);
        case 'SET_VALUES':
            return __assign(__assign({}, state), action.payload);
        default:
            throw new Error();
    }
}
/**
 * Provides an object containing form field values
 * and a function to set the field values using an
 * input's onChange callback, and a function to
 * clear the values.
 *
 * The key of each value is the name attribute of
 * the input field (taken from the event object).
 *
 * @param {object} initialValues The inital field values.
 */
var useForm = function (initialValues) {
    if (initialValues === void 0) { initialValues = {}; }
    var _a = __read(react_1.useReducer(reducer, initialValues), 2), values = _a[0], dispatch = _a[1];
    var onFieldChange = react_1.useCallback(function (event, checked) {
        var name = event.target.getAttribute('name');
        var value;
        if (name) {
            if (event.target.getAttribute('type') === 'checkbox') {
                value = checked;
            }
            else {
                (value = event.target.value);
            }
            dispatch({ type: 'SET_VALUE', name: name, value: value });
        }
    }, []);
    var clear = react_1.useCallback(function () {
        dispatch({ type: 'CLEAR', payload: initialValues });
    }, [initialValues]);
    var setValues = react_1.useCallback(function (newValues) {
        dispatch({ type: 'SET_VALUES', payload: newValues });
    }, []);
    return { values: values, onFieldChange: onFieldChange, clear: clear, setValues: setValues };
};
exports.default = useForm;
//# sourceMappingURL=useForm.js.map